import { useEffect } from 'react';

import TopNotification from 'coreOld/components/TopNotification';
import { Notification as NotificationType } from 'coreOld/elements';
import { ApiStatus, NotificationPosition } from 'core/enums';
import { useAppSelector } from 'coreOld/hooks';
import { useNotification } from 'coreOld/hooks/useNotification';

const SHOW_NOTIFICATION_TIME = 10000;

const TYPES_WITHOUT_TIMER = [ApiStatus.LOADING, ApiStatus.INFO, ApiStatus.WARNING];

interface IProps {
  position: NotificationPosition;
}

/** @deprecated */
export const Notification = ({ position }: IProps) => {
  const { notification } = useAppSelector((state) => state.notification);
  const { clearNotification } = useNotification();

  useEffect(() => {
    let timer;

    if (notification && !TYPES_WITHOUT_TIMER.includes(notification?.type)) {
      timer = setTimeout(() => clearNotification(), SHOW_NOTIFICATION_TIME);
    }

    return () => {
      clearTimeout(timer);
    };
  }, [notification]);

  let notificationType;
  const notificationMessage = notification?.message;

  switch (notification?.type) {
    case ApiStatus.ERROR:
      notificationType = ApiStatus.ERROR;
      break;
    case ApiStatus.LOADING:
      notificationType = ApiStatus.LOADING;
      break;
    case ApiStatus.SUCCESS:
      notificationType = ApiStatus.SUCCESS;
      break;
    case ApiStatus.INFO:
      notificationType = ApiStatus.INFO;
      break;
    case ApiStatus.WARNING:
      notificationType = ApiStatus.WARNING;
      break;
  }

  if (notification?.position !== position) {
    return;
  }

  if (notification?.position === NotificationPosition.TOP) {
    return (
      <TopNotification
        type={notificationType}
        message={notificationMessage}
        showNotification={notification?.position === NotificationPosition.TOP}
      />
    );
  }

  return (
    <NotificationType
      type={notificationType}
      message={notificationMessage}
      showNotification={notification?.position === position}
    />
  );
};

export default Notification;
